import * as React from 'react';
import Checkbox from './Checkbox';
import styled from 'react-emotion';
export const Radio = styled(Checkbox) `
  display: flex;
  margin-top: 1rem;
  & span {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
`;
const Label = styled('span') `
  font-weight: 600;
`;
export const CheckboxWrapper = styled('div') ``;
const CheckboxGroup = ({ selectedItem, items, handleChange, groupLabel }) => (React.createElement(CheckboxWrapper, null,
    groupLabel && React.createElement(Label, null, groupLabel),
    items.map(item => (React.createElement(Radio, { type: "radio", key: item.val, value: item.val, tabIndex: 0, checked: selectedItem === item.val ? true : false, label: item.label, onChange: () => handleChange(item.val) })))));
export default CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map